<!--
 *                                |~~~~~~~|
 *                                |       |
 *                                |       |
 *                                |       |
 *                                |       |
 *                                |       |
 *     |~.\\\_\~~~~~~~~~~~~~~xx~~~         ~~~~~~~~~~~~~~~~~~~~~/_//;~|
 *     |  \  o \_         ,XXXXX),                         _..-~ o /  |
 *     |    ~~\  ~-.     XXXXX`)))),                 _.--~~   .-~~~   |
 *      ~~~~~~~`\   ~\~~~XXX' _/ ';))     |~~~~~~..-~     _.-~ ~~~~~~~
 *               `\   ~~--`_\~\, ;;;\)__.---.~~~      _.-~
 *                 ~-.       `:;;/;; \          _..-~~
 *                    ~-._      `''        /-~-~
 *                        `\              /  /
 *                          |         ,   | |
 *                           |  '        /  |
 *                            \/;          |
 *                             ;;          |
 *                             `;   .       |
 *                             |~~~-----.....|
 *                            | \             \
 *                           | /\~~--...__    |
 *                           (|  `\       __-\|
 *                           ||    \_   /~    |
 *                           |)     \~-'      |
 *                            |      | \      '
 *                            |      |  \    :
 *                             \     |  |    |
 *                              |    )  (    )
 *                               \  /;  /\  |
 *                               |    |/   |
 *                               |    |   |
 *                                \  .'  ||
 *                                |  |  | |
 *                                (  | |  |
 *                                |   \ \ |
 *                                || o `.)|
 *                                |`\\) |
 *                                |       |
 *                                |       |
 * 
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-07-16 15:31:13
 * @LastEditTime: 2021-10-26 16:39:13
 * @FilePath: \uniapp-npm\lushh-comment-vue\src\components\commentsInput.vue
 * @Description: 
 -->

<template>
  <div>
    <div class="comment" v-if="!inputShowFix">
      <div class="comment-button" @click="commentsInput">
        <img :src="commentButtonIcon" class="comment-button-icon" />
        <p class="comment-button-p">我来说两句...</p>
      </div>
      <div class="comment-toolBar">
        <div class="comment-toolBar-commentIcon" @click="commentIcon">
          <p class="comment-toolBar-commentIcon-p">{{ commentCounts }}</p>
          <img
            :src="commentToolBarCommentIcon"
            class="comment-toolBar-commentIcon-img"
          />
        </div>
      </div>
    </div>
    <div
      class="comment-input"
      v-if="inputShowFix"
      @touchmove.stop.prevent="() => {}"
      @click.self="hideCommentsInput"
    >
      <div class="comment-input-content">
        <div class="comment-input-title">
          <img
            :src="commentInputTitleClose"
            class="comment-input-title-close"
            @click="inputShowFix = false"
          />
          <p class="comment-input-title-p">添加评论</p>
          <button
            type="primary"
            @click="publication"
            class="comment-input-title-button"
            :disabled="!inputValue"
          >
            发布
          </button>
        </div>
        <textarea
          v-model="inputValue"
          class="comment-input-textarea"
          placeholder="我来说两句"
          placeholder-style="color:#999999;font-size:22px;"
          confirm-type="send"
          maxlength="100"
          :fixed="true"
          :focus="true"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appFusionId: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    commentCounts: {
      type: String | Number,
      default: ''
    },
    objectTitle: {
      type: String,
      default: ''
    },
    objectId: {
      type: String,
      default: ''
    },
    parentCommentId: {
      type: String,
      default: ''
    },
    replyToComment: {
      type: String,
      default: ''
    },
    replyToUserId: {
      type: String,
      default: ''
    },
    inputShow: {
      type: Boolean,
      default: false
    },
    typeId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputShowFix: this.inputShow,
      inputValue: '',
      commentUserIcon: '',
      nickName: '',
      commentButtonIcon:
        'data:image/png;base64,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',
      commentToolBarCommentIcon:
        'data:image/png;base64,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',
      commentInputTitleClose:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAAAydJREFUaEPN2ktrE1EUAOBzZpIiInUhaBFcuHEnurJpk0wmDVQFi/4GQXFjEcGNiBt150LrouCvkIpPbJKmjW0FF9pf4K4bF3Fnk8mRpJmYJtPJfZw7M1mFyTzOl3MfJzcXYeDluu4R2/bOEXmNcvnrr8HPkvS+VCqd8pp/byG2T5NHK9WNzY9+fNh7g66Tu09EjxFpsnuM8Ls9Yd1cXV3/mSTM3NzMpXYL3wPAif8Ia6lS27jXjbpzsOjkXhK0FwMCb1gpmi+XN78lAdXDfAaA46Px4INqrf4cC7nMAlrWSkjAiUCFYwCI8M/RY5Mn0XVmlgHwzpgMxIoah/Fjt9P2BSzks88Q6aFAk4oFJYrpxm9NnMV5xzmzB62d4HY5wowUJYUh/FFdr1/sDgrZ7HQmbdudoS+gs8WDksIANFKQyn+p1Xb8YTtRKFkM2u3LlcrWduer74OSkikdzAgobpQuJhAUF4oDcygoahQXJhQUFYoTMxZkGsWNEQKZQpnACIO4UaYwUiAuVLGYmSbP+iRalQxOmgL15sGJVeQCnTLJNEY6Qz5YBUVEaDIzfmwHSh+RDKmietcJFb+yzWwwbmWQQp8S+b4aOhjlJjcYmWTzC0NpY1hATJliwbCBNFFsGFaQIooVww6SnGc6z2dfo9Aa5QZ7uALGv5wVxQLSwLCjtEEMGFaUFogRw4ZSBkliGjKlj84fBEogWUynnNnbI4xiMVMapILxFwElyySl0U8KJItpet6Ven17S6P2k0YJgzgwqj89ZPqUEIgTYxo1FmQCYxIVCjKJMYU6FBQFxgQqEBQlhhs1AooD46Nknx00+h0Ayd4waJ4RWQkJO0c2hmFUHyR7IxMYjkzt7ySRXJ41idFFSf+tHwVGFTUBqfPoOrNPAOCRQNtvRIlRRD0V3hoTB0YWhQjLmM/PXrcR3oRkKJbMDMcj0s89ghv7g0Ihu0REdwNQicCIZAoRX1XW6ov9DYBFJ/diaM/c76bnXRv+PSPQ14ye0svUu9ANgH4EhWzmqpWyFgBwlzD9ulqt7hqNTvHmrutOITVvA9BUu9V+u1bf+uDf6h/FE/xz7D7pawAAAABJRU5ErkJggg=='
    }
  },
  watch: {
    inputShow(newVal, oldVal) {
      this.inputShowFix = newVal
    }
  },
  methods: {
    hideCommentsInput() {
      this.inputShowFix = false
      this.inputValue = ''
      this.$emit('update:inputShow', false)
    },
    commentIcon() {
      this.$emit('scrollToComments')
    },
    commentsInput() {
      this.inputShowFix = true
    },
    async publication() {
      console.log('publication')
      if (this.token ?? false) {
        await this.getUserInfoByTokenSync()
        this.saveComment()
      } else {
        this.$emit('getToken')
      }
    },
    async getUserInfoByTokenSync() {
      let serviceLogic = (res) => {
        console.log('业务逻辑处理:')
        console.log(res)
        this.nickName = res.data.result.wxNickname
        this.commentUserIcon = res.data.result.icon
      }
      let res = await this.$api.saasUser.getUserInfoByTokenSync.request({
        header: {
          Authorization: this.token
        }
      })
      serviceLogic(res)
    },
    saveComment() {
      let serviceLogic = (res) => {
        console.log('业务逻辑处理:')
        console.log(res)
        if (res.data?.success ?? false) {
          uni.showToast({
            title: '评论成功'
          })
          this.$emit('update:refresh', true)
          this.hideCommentsInput()
        } else {
          uni.showToast({
            title: res.data.msg,
            duration: 2000
          })
          this.hideCommentsInput()
        }
      }
      this.$api.saasComment.saveComment
        .request({
          data: {
            appFusionId: this.appFusionId,
            objectId: this.objectId,
            commentUserNickname: this.nickName,
            commentUserIcon: this.commentUserIcon,
            content: this.inputValue,
            objectTitle: this.objectTitle,
            parentCommentId: this.parentCommentId,
            replyToComment: this.replyToComment,
            replyToUserId: this.replyToUserId,
            source: 2,
            typeId: this.typeId,
            publishFirst: true
          },
          header: {
            Authorization: this.token
          }
        })
        .then((res) => {
          serviceLogic(res)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.comment {
  box-sizing: border-box;
  background: #ffffff;
  width: 100%;
  padding: 0 15px;
  height: 58px;
  border-top: 2px solid #d8d8d8;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  &-button {
    width: 100px;
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    padding: 0 13px;
    flex-shrink: 1;
    flex-grow: 1;
    &-icon {
      width: 17px;
      height: 21px;
      margin-right: 8px;
    }
    &-p {
      color: #6e6e6e;
      font-size: 12px;
    }
  }
  &-toolBar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 50px;
    &-commentIcon {
      position: relative;
      &-p {
        position: absolute;
        right: -12px;
        top: -12px;
        color: #fd2828;
        font-size: 10px;
      }
      &-img {
        width: 22px;
        height: 20px;
      }
    }
  }
  &-input {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.7);
    z-index: 1;
    left: 0;
    top: 0;
    &-content {
      border-radius: 12px 12px 0px 0px;
      background: #ffffff;
      width: 1400px;
      left: 50%;
      margin-left: -700px;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      padding: 15px 15px 0 15px;
    }
    &-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      &-close {
        width: 13px;
        height: 13px;
      }
      &-p {
        font-size: 16px;
        font-weight: 500;
      }
      &-button {
        width: 50px;
        height: 24px;
        line-height: 24px;
        font-size: 15px;
        color: #ffffff;
        border-radius: 12px;
        padding: 0;
        margin: 0;
        background: #0071bc;
      }
    }
    &-textarea {
      width: 100%;
      height: 150px;
      margin: 15px 0;
      background: #f7f7f7;
      border-radius: 6px;
    }
  }
}
</style>
